import script from "./coverPageList.vue?vue&type=script&setup=true&lang=js"
export * from "./coverPageList.vue?vue&type=script&setup=true&lang=js"

import "./coverPageList.vue?vue&type=style&index=0&id=7bc9aa5c&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc9aa5c"]])

export default __exports__